__turbopack_context__.v({
  "column": "GenericTable-module-scss-module__5Uaxra__column",
  "column--unselected": "GenericTable-module-scss-module__5Uaxra__column--unselected",
  "columns": "GenericTable-module-scss-module__5Uaxra__columns",
  "columns--mobile": "GenericTable-module-scss-module__5Uaxra__columns--mobile",
  "link": "GenericTable-module-scss-module__5Uaxra__link",
  "name--desktop": "GenericTable-module-scss-module__5Uaxra__name--desktop",
  "name--mobile": "GenericTable-module-scss-module__5Uaxra__name--mobile",
  "row": "GenericTable-module-scss-module__5Uaxra__row",
  "section": "GenericTable-module-scss-module__5Uaxra__section",
  "sectionClosed": "GenericTable-module-scss-module__5Uaxra__sectionClosed",
  "sectionHeader": "GenericTable-module-scss-module__5Uaxra__sectionHeader",
  "sectionLabel": "GenericTable-module-scss-module__5Uaxra__sectionLabel",
  "sectionLabel--unselected": "GenericTable-module-scss-module__5Uaxra__sectionLabel--unselected",
  "subtitle": "GenericTable-module-scss-module__5Uaxra__subtitle",
  "table": "GenericTable-module-scss-module__5Uaxra__table",
  "title": "GenericTable-module-scss-module__5Uaxra__title",
  "tooltip": "GenericTable-module-scss-module__5Uaxra__tooltip",
  "tooltipContent": "GenericTable-module-scss-module__5Uaxra__tooltipContent",
  "value": "GenericTable-module-scss-module__5Uaxra__value",
  "value--showOnMobile": "GenericTable-module-scss-module__5Uaxra__value--showOnMobile",
  "values": "GenericTable-module-scss-module__5Uaxra__values",
});
